var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 2.66669C8.38422 2.66669 8.69567 2.97814 8.69567 3.36234V12.6377C8.69567 13.0219 8.38422 13.3334 8.00002 13.3334C7.61582 13.3334 7.30437 13.0219 7.30437 12.6377V3.36234C7.30437 2.97814 7.61582 2.66669 8.00002 2.66669Z",
    fill: "#0E46C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3334 8.00002C13.3334 8.38422 13.0219 8.69567 12.6377 8.69567H3.36234C2.97814 8.69567 2.66669 8.38422 2.66669 8.00002C2.66669 7.61582 2.97814 7.30437 3.36234 7.30437L12.6377 7.30437C13.0219 7.30437 13.3334 7.61582 13.3334 8.00002Z",
    fill: "#0E46C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d09c9c8e2728e1c93e81cfd3441455e4.svg";
export { ForwardRef as ReactComponent };